// @flow
import React, { Component } from 'react';
import {
  ModelRowTr,
  ModelListTh,
  SpacerTd
} from '../../../../../components/ModelListStyles';
import { Default, Desktop } from '../../../../../components/Responsive';

type Props = {};

export default class FailedMerchantsTableHead extends Component<Props> {
  render() {
    return (
      <thead>
        <ModelRowTr>
          <SpacerTd />
          <ModelListTh>Business name</ModelListTh>
          <ModelListTh rightMobile>Notes</ModelListTh>
          <Desktop>
            <ModelListTh right>Email</ModelListTh>
          </Desktop>
          <Default>
            <ModelListTh right>{''}</ModelListTh>
          </Default>
          <SpacerTd />
        </ModelRowTr>
      </thead>
    );
  }
}
